<script>
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import GetAFreeEstimate from '$lib/PageSections/GetAFreeEstimate/GetAFreeEstimate.svelte';
	import Solutions from '$lib/PageSections/Solutions/Solutions.svelte';

	import customerStories from './images/customer-stories.jpg';
	import customerStories2 from './images/customer-stories2.jpg';
	import customerStories3 from './images/customer-stories3.jpg';
</script>

<Section>
	<Image src={customerStories} class="no-bleed" alt="old house windows" />
	<p>
		This Old House specializes in restoring homes that make viewers sigh with
		"I-want-to-live-there" envy.
	</p>
	<p>
		The "Single House" in the Ansonborough neighborhood of Charleston is no
		exception. This Old House Charleston is the latest makeover by the
		long-running television show that airs on public broadcasting. And we're
		happy to say Indow inserts helped make the original single-pane windows
		energy efficient and reduced the noise coming in off the street with
		<a href="/solutions/window-noise-reduction">Acoustic Grade</a> inserts.
	</p>
	<p>
		"There's no noise," said Scott Edwards who owns the house with his wife
		Kathleen. "It's a huge difference."
	</p>
</Section>

<Section>
	<h2>Blocking Street Noise in a Historic District</h2>
	<p>
		The couple moved from the suburbs to live in Charleston where they could
		walk to restaurants and shops. At first, they renovated a house a few blocks
		away. That house had aluminium exterior storms over single-pane windows but
		it was as if there were no windows at all, it was still so loud inside the
		house. They knew they needed to do something different in the "Single
		House."
	</p>
	<p>
		And not just for noise. Single-pane windows are drafty. The Board of
		Architectural Review in Charleston told them that if they replaced the
		windows, they still had to be single-pane and divided light.
	</p>
	<p>
		Scott knew he could get thicker single-pane glass, but the R-value (or
		insulating power) would still be lousy. And so would its ability to reduce
		outside noise.
	</p>
	<p>
		"Why am I going to spend all this money to get nominally better windows when
		we can renovate these existing windows?"
	</p>
	<Image
		src={customerStories2}
		class="no-bleed"
		alt="window with sun shining through"
	/>
</Section>

<Section>
	<h2>Acoustic Windows on This Old House</h2>
	<p>
		The original windows are pretty amazing. They're deeply inset in the home's
		walls, which are several bricks thick. Because of this, there can be a lot
		of space between the Indow insert and the window – and the greater the air
		space, the better the sound damping. There's no need at all anymore to
		replace windows to make them quieter.
	</p>
	<p>
		"Here, it's like a house with double or triple-pane windows," he said,
		comparing it to their old house a few blocks away. "I hear very little."
	</p>
	<p>
		And the inserts blend into the existing frame so well Scott has forgotten
		they were there and hit his head trying to peer out the window.
	</p>
	<Image src={customerStories3} alt="porch windows with shutters" />
</Section>

<Section>
	<h2>Old House Renovation</h2>
	<p>
		Nothing had been done on the house for more than 60 years. Two brothers had
		lived there and as the story goes, their mother instructed them to never
		marry so they could care for their sister. The house needed a lot of work,
		which gave Scott and his wife Kathleen a blank slate for making it over.
	</p>
	<p>
		As part of the This Old House renovation, they had spray foam insulation
		added in the attic and under the house and installed a new and more
		efficient HVAC system. He anticipates the inserts will help with the
		expensive air conditioning bills Charleston residents regularly incur.
	</p>
	<p>"You walk by a window and there's no draft."</p>
	<p>
		Indow is grateful to be a part the Single House project. We appreciate the
		time and thought This Old House – as well as all the other craftspeople –
		put into making the house a true gem.
	</p>
</Section>

<GetAFreeEstimate />

<Solutions />
